import { useApplicationDispatch, useApplicationSelector } from '../../../../../Redux/ReduxStore';
import { selectValueMatrixTableInputsRequest, setValueMatrixTableInputsRequest } from '../../../../../Redux/Slices/ValueMatrixCalculatorSlice';
import Dropdown from '../../../../Components/Form/Inputs/Dropdown';
import LabelWithTooltip from '../../../../Components/Form/Inputs/LabelWithTooltip';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import styles from '../ValueMatrixCalculator.module.scss';
import { timeSpanOptions } from '../ValueMatrixDefinitions';

const ValueMatrixOuterRangeDropdown: React.FC = () => {
    const [translations] = useLanguage();
    const dispatch = useApplicationDispatch();
    const valueMatrixTableInputs = useApplicationSelector(selectValueMatrixTableInputsRequest);

    return (
        <div className={styles.value_matrix_dropdown}>
            <Dropdown
                testId="ValueMatrixOuterRangeDropdown"
                value={valueMatrixTableInputs.weighted?.outerRange}
                options={timeSpanOptions}
                handleOptionChange={(value: number) => {
                    dispatch(
                        setValueMatrixTableInputsRequest({
                            ...valueMatrixTableInputs,
                            weighted: {
                                ...valueMatrixTableInputs.weighted,
                                outerRange: value,
                            },
                            updateTriggeredBy: 'generalFieldSelectionOrUpdate',
                        }),
                    );
                }}
                label={
                    <LabelWithTooltip
                        title={translations.calculators.valueMatrix.fields.outerRange}
                        tooltip={translations.calculators.valueMatrix.text.outerRangeTooltipInformation}
                    />
                }
                track={{ eventCategory: 'ValueMatrixCalculator', eventAction: 'OuterRangeChanged' }}
            />
        </div>
    );
};

export default ValueMatrixOuterRangeDropdown;
